<template> 
        <!--<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5HBXJ7" height="0" width="0" style="display:none;visibility:hidden"></iframe>-->
        <div></div>

</template>

<style scoped>
    iframe .open{
        height: 92vh !important;
    }
</style>
      
<script type="text/javascript">
</script>
<script>





export default {
  name: 'chat',
  data(){
     return {
        nombre:'',
        mayorista:'',
        mail:'',
        reserva:'',
        src:'https://www.google.com/',
     }
  },
  props: [],
  methods:{
      
  },
  computed:{
    
  },
  beforeCreate: function() {
    window.$crisp=[];window.CRISP_WEBSITE_ID="77a74e9c-66d0-40bb-827a-36c31685775c";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
  },
  async created(){
     /*let mayoristas =[];
     let mayorista =  await base.ref("RVA/Mayoristas/Coleccion").once("value");
     

     let arrayMayoristas =  Object.entries(mayorista.val());
        
     arrayMayoristas.forEach((element)=>{
        mayoristas.push({id:element[0],...element[1]}); 
     });
    
      let claims = this.$route.params.user.tokenResult.claims;
   
      this.reserva = this.$route.params.confirmacion
      this.nombre = claims.name;
      if(claims.Type == "Admin"){
          this.mayorista = encodeURIComponent("Administrador");
          this.mail      = encodeURIComponent("admin@puertocancun.com");
      }else{
          this.mayorista = encodeURIComponent(this.$pgsHelper.getById(mayoristas,'Codigo',claims.Code).Nombre);
          this.mail      = encodeURIComponent("mayorista@puertocancun");
      }
    
    
     this.src= 'https://dad0jyjolxgoz.cloudfront.net/chat/0/'+this.mayorista+'/'+this.mail+'/'+this.reserva+'/puertocancun'
      */
  },
 
  mounted() {

    setTimeout(function(){ 
        //this.$pgsHelper.log(document.querySelectorAll("iframe")[1]); 
       
        document.querySelectorAll("iframe")[0].style="height: 90vh !important;  width:97vw;";
    }, 1000);

    
  }
  
}
</script>